import { getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('users init')
}

export async function list(app, apiHost, pageNo = 1, searchText = '', onlyDeactivated = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${encodeURIComponent(searchText || '')}&onlyDeactivated=${onlyDeactivated}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function get(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function add(post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function search(app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function userSearch(id, app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/users/${id}/friends?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function groupSearch(id, app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/users/${id}/groups?hasJoined=1&searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function inactiveSearch(app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&onlyDeactivated=1&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      data: {
        permanent: true,
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deactivate(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function activate(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users`
  const post = { uidsToActivate: [id] }
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenDel(id, uid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${uid}/auth_tokens/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenList(id, app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/auth_tokens?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

// export async function groupList(id, app, apiHost, pageNo = 1, searchKey = '') {
//   let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
//   URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/groups?hasJoined=1&per_page=${
//     constants.perPageInListings
//   }&page=${pageNo}&searchKey=${searchKey}`
//   return axios
//     .get(`${URL}`, {
//       headers: {
//         appId: app.id,
//         apiKey: app.accessKey,
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//     })
//     .then(res => {
//       return res.data
//     })
//     .catch(error => {
//       return error.response.data
//     })
// }

export async function groupList(id, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/groups?hasJoined=1&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function searchGroupList(id, app, apiHost, pageNo = 1, searchKey = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/groups?hasJoined=1&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchKey}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function friendList(id, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/friends?&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchFriendList(id, app, apiHost, pageNo = 1, searchKey = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/friends?&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchKey}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenAdd(uid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${uid}/auth_tokens`
  return axios
    .post(
      `${URL}`,
      { force: true },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
export async function authTokenSearch(uid, app, apiHost, searchText) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/users/${uid}/auth_tokens?searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateFriends(uid, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${uid}/friends`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function removeFriends(uid, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${uid}/friends`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      data: {
        friends: post,
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function addToGroup(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members`
  return axios
    .post(
      `${URL}`,
      { participants: [uid] },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function kickFromGroup(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function banFromGroup(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .post(
      `${URL}`,
      {},
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateScopeInGroup(uid, guid, scope, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members`
  let scopeData = { participants: [uid] }
  if (scope === 'Admin') {
    scopeData = { admins: [uid] }
  } else if (scope === 'Moderator') {
    scopeData = { moderators: [uid] }
  }
  return axios
    .post(`${URL}`, scopeData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getMultiple(ids, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users?uids=${ids}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function aiAgentUserList(
  app,
  apiHost,
  pageNo = 1,
  searchText = '',
  onlyDeactivated = 0,
  role = '@agentic',
  perPage = '10',
) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/users?per_page=${perPage}&page=${pageNo}&searchKey=${searchText}&onlyDeactivated=${onlyDeactivated}&useCursoredIndex=1&role=${role}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
